/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Artifact_List_No_Artifacts_DescriptionInputs */



/**
* | output |
* | --- |
* | "Start creating artifacts by generating content in your projects." |
*
* @param {Artifact_List_No_Artifacts_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const artifact_list_no_artifacts_description = /** @type {((inputs?: Artifact_List_No_Artifacts_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Artifact_List_No_Artifacts_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Beginne mit der Erstellung von Artefakten, indem du Inhalte in deinen Projekten generierst.")
	return /** @type {LocalizedString} */ ("Start creating artifacts by generating content in your projects.")
});